export const FetchLocations = async ({ selectedProjectId }) => {
    console.log("fetching locations:");

    const request = new Request(`${process.env.REACT_APP_API_URL}/api/locations?projectId=${selectedProjectId}`, {
        method: 'GET',
        credentials: 'include',
    });

    try {
        const response = await fetch(request);
        console.log('Response fetching locations:', response);

        if (!response.ok) {
            throw new Error(`HTTP error from fetching location! Status: ${response.status} ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};